import PropTypes from 'prop-types';
import { useMemo } from 'react';
import CategoryTableFilter from 'src/components/category-table-filter';
import { useGetActiveEstimateCategoriesQuery } from 'src/store/Reducer/estimate-category';

// Category filter for the Primary Service / Additional Service / Terms & Conditions listing
// toolbars. Fed by the same source as the add/edit dropdown
// (useGetActiveEstimateCategoriesQuery) so the two stay in sync. `type` is one of
// ESTIMATE_CATEGORY_TYPES; `value` is the selected array of category ids; `onChange`
// receives the next array of ids. Rendering is delegated to the shared CategoryTableFilter.
const EstimateCategoryTableFilter = ({ type, value, onChange, size = 'small' }) => {
  const { data, isLoading } = useGetActiveEstimateCategoriesQuery(type, { skip: !type });

  const options = useMemo(
    () => (data?.body || []).map((category) => ({ value: category._id, label: category.title })),
    [data]
  );

  return (
    <CategoryTableFilter
      options={options}
      value={value}
      onChange={onChange}
      loading={isLoading}
      size={size}
    />
  );
};

EstimateCategoryTableFilter.propTypes = {
  type: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium']),
};

export default EstimateCategoryTableFilter;
